<template>
  <div class="">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="isEdit ? $t('components.Add.800967-0') : $t('components.Add.800967-1')"
      :close-on-click-modal="false"
      :visible.sync="show"
      width="1200px"
      @close="closeDialog"
    >
      <!-- 语言切换 -->
      <div style="margin-bottom: 15px">
        <el-radio-group v-model="editorLang" size="small">
          <el-radio-button v-for="lang in languages" :key="lang.code" :label="lang.code">
            {{ lang.name }}
          </el-radio-button>
        </el-radio-group>
        <span style="margin-left: 10px; color: #909399; font-size: 12px">
          {{ $t("components.Add.800967-2") }}
          {{ (languages.find(l => l.code === editorLang) || {}).name || $t("components.Add.800967-3") }}
        </span>
      </div>
      <el-form :model="form" :rules="rules" label-position="top">
        <el-divider></el-divider>
        <!-- <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('components.Add.368702-0')" prop="type">
              <el-select v-model="form.type" :placeholder="$t('components.Add.368702-1')">
                <el-option :label="$t('components.Add.368702-2')" :value="1"></el-option>
                <el-option :label="$t('components.Add.368702-3')" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider> -->
        <!-- 将问卷基本信息移入 el-form -->
        <el-row :gutter="20" style="margin-bottom: 0">
          <el-col :span="8">
            <el-form-item :label="getPlaceholder($t('components.Add.800967-9'))" prop="name" required>
              <el-input :placeholder="getPlaceholder($t('components.Add.800967-9'))" v-model="form.name[editorLang]">
                <span v-if="isEdit" style="margin-left: 10px; font-size: 12px; color: #999">
                  {{ $t("components.Add.800967-10") }} {{ editorLang }}{{ $t("components.Add.800967-11") }}
                  {{ !!form.name[editorLang] }}
                </span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('components.Add.800967-13')" prop="dateRange">
              <el-date-picker
                v-model="form.dateRange"
                type="datetimerange"
                :range-separator="$t('components.Add.800967-14')"
                :start-placeholder="$t('components.Add.800967-15')"
                :end-placeholder="$t('components.Add.800967-16')"
                value-format="yyyy-MM-dd HH:mm:ss"
                class="custom-date-picker"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 优惠券选择 -->
            <el-form-item :label="$t('components.Add.800967-17')" prop="discountId">
              <el-select
                v-model="form.discountId"
                :placeholder="$t('components.Add.800967-18')"
                filterable
                remote
                :remote-method="remoteMethod"
                :loading="discountLoading"
                clearable
                style="width: 100%"
                v-el-select-loadmore="loadMoreDiscounts"
              >
                <el-option
                  v-for="discount in discountList"
                  :key="discount.id"
                  :label="discount.name"
                  :value="discount.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="getPlaceholder($t('components.Add.800967-12'))" prop="description">
              <el-input
                type="textarea"
                :rows="2"
                maxlength="500"
                show-word-limit
                :placeholder="getPlaceholder($t('components.Add.800967-12'))"
                v-model="form.description[editorLang]"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div style="color: red; font-size: 12px; margin-top: 42px">
              {{ $t("components.Add.850551-0") }}({{ $t("components.Add.850551-1") }}){{
                $t("components.Add.850551-2")
              }}
              {{ $t("components.Add.850551-3") }}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" v-if="form.type === 1">
            <el-form-item :label="$t('components.Add.368702-2')" prop="url">
              <el-input :placeholder="$t('components.Add.368702-4')" v-model="form.url"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider v-if="form.type === 2"></el-divider>
      <el-row v-if="form.type === 2">
        <!-- 左侧 -->
        <el-col :span="4">
          <ul class="component-list">
            <li @click="handlerAddItem('text')">{{ $t("components.Add.800967-4") }}</li>
            <li @click="handlerAddItem('textarea')">{{ $t("components.Add.800967-5") }}</li>
            <li @click="handlerAddItem('radio')">{{ $t("components.Add.800967-6") }}</li>
            <li @click="handlerAddItem('checkbox')">{{ $t("components.Add.800967-7") }}</li>
            <li @click="handlerAddItem('rating')">{{ $t("components.Add.800967-8") }}</li>
          </ul>
        </el-col>
        <!-- 中间 -->
        <el-col :span="14" style="padding: 0 20px">
          <el-card style="margin: 0 10px">
            <div class="preview-container" ref="previewContainer">
              <el-form :model="form" :rules="rules" label-position="top">
                <!-- 分割线或提示，表示以下是动态问题 -->
                <el-divider v-if="content.length > 0">{{ $t("components.Add.800967-19") }}</el-divider>

                <draggable v-model="content" handle=".drag-handle" animation="300">
                  <div
                    v-for="item in content"
                    :key="item.timesp"
                    class="form-item-container"
                    :id="`item-${item.timesp}`"
                    style="margin-bottom: 10px; position: relative; padding: 8px"
                  >
                    <div
                      @click="handlerChooseItem(item)"
                      class="choose-item"
                      :class="{ 'choose-active': item.timesp === chooseItem.timesp }"
                    ></div>
                    <div class="item-actions">
                      <i class="el-icon-rank drag-handle"></i>
                      <i class="el-icon-close" @click.stop="handlerDeleteItem(item)"></i>
                    </div>
                    <!-- {{ $t('components.Add.800967-4') }} -->
                    <template v-if="item.type === 'text'">
                      <el-form-item :label="item.title[editorLang]" :required="item.required">
                        <el-input v-model="item.value" :placeholder="item.placeholder[editorLang]"></el-input>
                      </el-form-item>
                    </template>
                    <!-- {{ $t('components.Add.800967-5') }}-->
                    <template v-if="item.type === 'textarea'">
                      <el-form-item :label="item.title[editorLang]" :required="item.required">
                        <el-input
                          type="textarea"
                          v-model="item.value"
                          :placeholder="item.placeholder[editorLang]"
                        ></el-input>
                      </el-form-item>
                    </template>
                    <!-- {{ $t('components.Add.800967-6') }}-->
                    <template v-if="item.type === 'radio'">
                      <el-form-item :label="item.title[editorLang]" :required="item.required">
                        <el-radio-group v-model="item.value">
                          <el-radio v-for="ite in item.list" :key="ite.value" :label="ite.value">
                            {{ ite.label[editorLang] }}
                          </el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </template>
                    <!-- {{ $t('components.Add.800967-7') }} -->
                    <template v-if="item.type === 'checkbox'">
                      <el-form-item :label="item.title[editorLang]" :required="item.required">
                        <el-checkbox-group v-model="item.value">
                          <el-checkbox v-for="ite in item.list" :key="ite.value" :label="ite.value">
                            {{ ite.label[editorLang] }}
                          </el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </template>
                    <!-- {{ $t('components.Add.800967-8') }} -->
                    <template v-if="item.type === 'rating'">
                      <el-form-item :label="item.title[editorLang]" :required="item.required">
                        <el-rate v-model="item.value" :max="5"></el-rate>
                        <!-- 添加条件显示的文本输入框 -->
                        <el-input
                          type="textarea"
                          v-model="item.textareaValue"
                          :placeholder="item.textareaPlaceholder[editorLang]"
                          style="margin-top: 10px"
                          :rows="3"
                        ></el-input>
                      </el-form-item>
                    </template>
                  </div>
                </draggable>
              </el-form>
            </div>
          </el-card>
        </el-col>
        <!-- 右侧 -->
        <el-col :span="6">
          <!-- 没选择 -->
          <div v-if="!chooseItem.timesp" style="color: #666; text-align: center; padding: 10px 0">
            {{ $t("components.Add.800967-20") }}
          </div>
          <template v-else>
            <el-form label-position="top">
              <el-form-item :label="$t('components.Add.800967-21')">
                <el-input type="input" v-model="chooseItem.title[editorLang]"></el-input>
              </el-form-item>

              <el-form-item :label="$t('components.Add.800967-22')">
                <el-radio v-model="chooseItem.required" :label="true">{{ $t("components.Add.800967-23") }}</el-radio>
                <el-radio v-model="chooseItem.required" :label="false">{{ $t("components.Add.800967-24") }}</el-radio>
              </el-form-item>

              <!-- 文本类型组件的占位符配置 -->
              <template v-if="chooseItem.type === 'text' || chooseItem.type === 'textarea'">
                <el-form-item :label="$t('components.Add.800967-25')">
                  <el-input
                    v-model="chooseItem.placeholder[editorLang]"
                    :placeholder="getPlaceholder($t('components.Add.800967-26'))"
                  ></el-input>
                </el-form-item>
              </template>

              <!-- 评分组件特有配置 -->
              <template v-if="chooseItem.type === 'rating'">
                <!-- 文本框占位符配置，仅当showTextarea为true时显示 -->
                <el-form-item :label="$t('components.Add.800967-27')">
                  <el-input
                    v-model="chooseItem.textareaPlaceholder[editorLang]"
                    :placeholder="getPlaceholder($t('components.Add.800967-28'))"
                  ></el-input>
                </el-form-item>
              </template>

              <!-- 单选框和多选框的选项配置 -->
              <template v-if="chooseItem.type === 'radio' || chooseItem.type === 'checkbox'">
                <div style="margin-top: 20px; float: right">
                  <el-button type="text" @click="handlerAddInTable" size="small">{{
                    $t("components.Add.800967-29")
                  }}</el-button>
                </div>
                <el-table style="margin-top: 10px; width: 100%" :data="chooseItem.list" border>
                  <el-table-column :label="$t('components.Add.800967-30')" prop="label" width="180">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.label[editorLang]" type="text" size="small" />
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('components.Add.800967-31')">
                    <template slot-scope="scope">
                      <el-button size="mini" type="danger" @click="handlerDelInTable(scope.$index)">{{
                        $t("components.Add.800967-32")
                      }}</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-form>
          </template>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t("components.Add.800967-33") }}</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm">{{
          $t("components.Add.800967-34")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import draggable from "vuedraggable";
  import { debounce } from "lodash";

  // 定义 el-select 触底加载指令
  const elSelectLoadmore = {
    bind(el, binding) {
      const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
      if (SELECTWRAP_DOM) {
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  };

  export default {
    directives: {
      "el-select-loadmore": elSelectLoadmore // 注册指令
    },
    components: {
      draggable
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      editData: {
        type: Object,
        default: null
      },
      isEdit: {
        type: Boolean,
        default: false
      },
      languages: {
        type: Array,
        default: () => []
      },
      currentLang: {
        type: String,
        default: "zh"
      }
    },
    data() {
      return {
        rules: {
          url: [{ required: true, message: this.$t("components.Add.368702-4"), trigger: "blur" }],
          name: [{ required: true, message: this.$t("components.Add.368702-5"), trigger: "blur" }],
          description: [{ required: true, message: this.$t("components.Add.368702-6"), trigger: "blur" }]
          // dateRange: [{ required: true, message: this.$t("components.Add.368702-7"), trigger: "blur" }]
        },
        editorLang: this.currentLang || "",
        form: {
          name: {},
          type: 1,
          url: "",
          description: {},
          dateRange: [],
          discountId: null
        },
        content: [],
        discountList: [],
        discountLoading: false,
        discountPageIndex: 1,
        discountPageSize: 10,
        discountTotal: 0,
        discountSearchName: "",
        componentsArr: [
          {
            type: "text",
            name: this.$t("components.Add.800967-4"),
            title: {},
            placeholder: {},
            required: true,
            value: ""
          },
          {
            type: "textarea",
            name: this.$t("components.Add.800967-5"),
            title: {},
            placeholder: {},
            required: true,
            value: ""
          },
          {
            type: "radio",
            name: this.$t("components.Add.800967-6"),
            title: {},
            placeholder: {},
            required: true,
            value: "",
            list: [
              { value: "option1", label: {} },
              { value: "option2", label: {} }
            ]
          },
          {
            type: "checkbox",
            name: this.$t("components.Add.800967-7"),
            title: {},
            placeholder: {},
            required: true,
            value: [],
            list: [
              { value: "option1", label: {} },
              { value: "option2", label: {} }
            ]
          },
          {
            type: "rating",
            name: this.$t("components.Add.800967-8"),
            title: {},
            placeholder: {},
            required: true,
            value: 0,
            textareaValue: "",
            textareaPlaceholder: {}
          }
        ],
        chooseItem: {},
        dragItem: null,
        submitLoading: false,
        hasChanged: false
      };
    },
    watch: {
      editData: {
        handler(val) {
          if (val) {
            this.initEditData();
          }
        },
        immediate: true
      },
      currentLang: {
        handler(val) {
          if (val) {
            this.editorLang = val;
          }
        },
        immediate: true
      },
      show: {
        handler(newVal) {
          if (newVal) {
            this.resetDiscountState();
            this.fetchDiscountList();
          }
        },
        immediate: true
      },
      languages: {
        handler(val) {
          if (val && val.length > 0) {
            if (!this.editorLang && val[0].code) {
              this.editorLang = val[0].code;
            }
            this.initComponentsDefaultLang();
          }
        },
        immediate: true
      }
    },
    created() {
      if (!this.editorLang) {
        this.editorLang = this.$cookies.get("lang") || "zh";
      }
      this.debouncedFetchDiscountList = debounce(this.fetchDiscountList, 500);
    },
    methods: {
      async fetchDiscountList(loadMore = false) {
        if (this.discountLoading) return;
        this.discountLoading = true;
        try {
          const params = {
            pageIndex: this.discountPageIndex,
            pageSize: this.discountPageSize,
            name: this.discountSearchName
          };
          const res = await this.$api.request(this.$url.MyApps.getCoupon, this.$method.get, params);
          if (res.code === 0 && res.data) {
            const newDiscounts = res.data.records || [];
            if (loadMore) {
              this.discountList = [...this.discountList, ...newDiscounts];
            } else {
              this.discountList = newDiscounts;
            }
            this.discountTotal = res.data.total || 0;
          } else {
            this.$message.warning(res.msg || this.$t("components.Add.800967-35"));
            if (!loadMore) {
              this.discountList = [];
              this.discountTotal = 0;
            }
          }
        } catch (error) {
          console.error(this.$t("components.Add.800967-35"), error);
          this.$message.error(this.$t("components.Add.800967-35"));
          if (!loadMore) {
            this.discountList = [];
            this.discountTotal = 0;
          }
        } finally {
          this.discountLoading = false;
        }
      },
      remoteMethod(query) {
        this.discountSearchName = query;
        this.discountPageIndex = 1;
        this.debouncedFetchDiscountList();
      },
      loadMoreDiscounts() {
        const hasMore = this.discountList.length < this.discountTotal;
        if (hasMore && !this.discountLoading) {
          this.discountPageIndex++;
          this.fetchDiscountList(true);
        }
      },
      resetDiscountState() {
        this.discountList = [];
        this.discountLoading = false;
        this.discountPageIndex = 1;
        this.discountTotal = 0;
        this.discountSearchName = "";
      },
      initComponentsDefaultLang() {
        if (!this.languages || this.languages.length === 0) return;

        this.componentsArr.forEach(comp => {
          if (comp.type === "text") {
            comp.title = this.createMultiLangObject(this.$t("components.Add.800967-36"));
            comp.placeholder = this.createMultiLangObject(this.$t("components.Add.800967-37"));
          } else if (comp.type === "textarea") {
            comp.title = this.createMultiLangObject(this.$t("components.Add.800967-38"));
            comp.placeholder = this.createMultiLangObject(this.$t("components.Add.800967-39"));
          } else if (comp.type === "radio") {
            comp.title = this.createMultiLangObject(this.$t("components.Add.800967-40"));
            comp.placeholder = this.createMultiLangObject(this.$t("components.Add.800967-41"));
          } else if (comp.type === "checkbox") {
            comp.title = this.createMultiLangObject(this.$t("components.Add.800967-42"));
            comp.placeholder = this.createMultiLangObject(this.$t("components.Add.800967-43"));
          } else if (comp.type === "rating") {
            comp.title = this.createMultiLangObject(this.$t("components.Add.800967-44"));
            comp.placeholder = this.createMultiLangObject(this.$t("components.Add.800967-45"));
            comp.textareaPlaceholder = this.createMultiLangObject(this.$t("components.Add.800967-28"));
          }

          if (comp.list) {
            comp.list.forEach((item, index) => {
              item.label = this.createMultiLangObject(this.$t("components.Add.800967-46", [index + 1]));
            });
          }
        });

        this.form.name = this.createMultiLangObject(this.$t("components.Add.800967-47"));
        this.form.description = this.createMultiLangObject(this.$t("components.Add.800967-12"));
      },

      initEditData() {
        // if (!this.editData) return;

        this.form.dateRange = [this.editData.startTime || "", this.editData.endTime || ""];
        this.form.discountId = this.editData.discountId || null;
        this.$set(this.form, "type", this.editData.type || 1);
        this.$set(this.form, "url", this.editData.url || "");

        // 使用 Vue.set 确保响应式
        this.form.name = {};
        this.form.description = {};

        // 先将所有语言设置为默认值
        this.languages.forEach(lang => {
          this.$set(this.form.name, lang.code, "");
          this.$set(this.form.description, lang.code, "");
        });

        // 然后设置已有的语言值
        if (this.editData.language && this.editData.language.length > 0) {
          this.editData.language.forEach(lang => {
            this.$set(this.form.name, lang.lang, lang.title);
            this.$set(this.form.description, lang.lang, lang.description);
          });
        } else {
          this.languages.forEach(lang => {
            this.$set(this.form.name, lang.code, this.editData.title || this.$t("components.Add.800967-48"));
            this.$set(this.form.description, lang.code, this.editData.description || "");
          });
        }

        this.content = [];
        if (this.editData.questions && this.editData.questions.length > 0) {
          this.editData.questions.forEach(question => {
            const item = {
              id: question.id,
              timesp: Date.now() + Math.random() * 1000,
              type: this.mapQuestionType(question.type),
              required: question.required === 1,
              title: {},
              placeholder: {},
              value: "",
              sort: question.sort
            };

            if (question.language && question.language.length > 0) {
              question.language.forEach(lang => {
                item.title[lang.lang] = lang.title;
                item.placeholder[lang.lang] = lang.placeholder;
              });
            }

            if (
              question.options &&
              question.options.length > 0 &&
              (item.type === "radio" || item.type === "checkbox")
            ) {
              item.list = question.options.map(option => {
                const optionItem = {
                  value: option.id,
                  label: {}
                };

                if (option.language && option.language.length > 0) {
                  option.language.forEach(lang => {
                    optionItem.label[lang.lang] = lang.title;
                  });
                }

                return optionItem;
              });
            }

            if (item.type === "rating") {
              item.textareaValue = "";
              item.textareaPlaceholder = this.createMultiLangObject(this.$t("components.Add.800967-28"));

              if (question.language && question.language.length > 0) {
                question.language.forEach(lang => {
                  if (lang.textareaPlaceholder) {
                    item.textareaPlaceholder[lang.lang] = lang.textareaPlaceholder;
                  }
                });
              }
            }

            this.content.push(item);
          });

          if (this.content.length > 0) {
            this.chooseItem = this.content[0];
          }
        } else {
          console.log(this.$t("components.Add.368702-9"));
        }
      },

      initQuestionsData(questions) {
        this.content = [];

        questions.forEach(question => {
          const item = {
            id: question.id,
            timesp: Date.now() + Math.random() * 1000,
            type: this.mapQuestionType(question.type),
            required: question.required === 1,
            title: {},
            placeholder: {},
            value: "",
            sort: question.sort
          };

          if (question.language && question.language.length > 0) {
            question.language.forEach(lang => {
              item.title[lang.lang] = lang.title;
              item.placeholder[lang.lang] = lang.placeholder;
            });
          }

          if (question.options && question.options.length > 0 && (item.type === "radio" || item.type === "checkbox")) {
            item.list = question.options.map(option => {
              const optionItem = {
                value: option.id,
                label: {}
              };

              if (option.language && option.language.length > 0) {
                option.language.forEach(lang => {
                  optionItem.label[lang.lang] = lang.title;
                });
              }

              return optionItem;
            });
          }

          if (item.type === "rating") {
            item.textareaValue = "";
            item.textareaPlaceholder = this.createMultiLangObject(this.$t("components.Add.800967-28"));

            if (question.language && question.language.length > 0) {
              question.language.forEach(lang => {
                if (lang.textareaPlaceholder) {
                  item.textareaPlaceholder[lang.lang] = lang.textareaPlaceholder;
                }
              });
            }
          }

          this.content.push(item);
        });

        if (this.content.length > 0) {
          this.chooseItem = this.content[0];
        }
      },

      mapQuestionType(type) {
        const typeMap = {
          text: "text",
          textarea: "textarea",
          single_choice: "radio",
          multiple_choice: "checkbox",
          rating: "rating"
        };
        return typeMap[type] || type;
      },

      reverseMapQuestionType(type) {
        const typeMap = {
          text: "text",
          textarea: "textarea",
          radio: "single_choice",
          checkbox: "multiple_choice",
          rating: "rating"
        };
        return typeMap[type] || type;
      },

      createMultiLangObject(defaultText) {
        const obj = {};
        this.languages.forEach(lang => {
          obj[lang.code] = defaultText;
        });
        return obj;
      },

      handlerDelInTable(idx) {
        this.chooseItem.list.splice(idx, 1);
      },

      handlerAddItem(type) {
        const info = JSON.parse(JSON.stringify(this.componentsArr.find(item => item.type === type)));
        info.timesp = Date.now();

        this.content.push(info);
        this.chooseItem = info;

        this.$nextTick(() => {
          this.scrollToElement(info.timesp);
        });
      },

      handlerChooseItem(item) {
        this.chooseItem = item;
        this.scrollToElement(item.timesp);
      },

      scrollToElement(timesp) {
        this.$nextTick(() => {
          const element = document.getElementById(`item-${timesp}`);
          if (element && this.$refs.previewContainer) {
            this.$refs.previewContainer.scrollTop = element.offsetTop - this.$refs.previewContainer.offsetTop;
          }
        });
      },

      handlerDeleteItem(item) {
        let delItem = item || this.chooseItem;
        let delIdx = this.content.findIndex(i => i.timesp === delItem.timesp);
        this.content.splice(delIdx, 1);

        if (this.content.length > 0) {
          this.chooseItem = this.content[0];
        } else {
          this.chooseItem = {};
        }
      },

      getPlaceholder(defaultText) {
        return defaultText;
      },

      closeDialog() {
        this.$emit("close", this.hasChanged);
        this.resetForm();
      },

      resetForm() {
        this.form = {
          name: this.createMultiLangObject(this.$t("components.Add.800967-47")),
          description: this.createMultiLangObject(this.$t("components.Add.800967-12")),
          type: 1,
          url: "",
          dateRange: [],
          discountId: null
        };
        this.content = [];
        this.chooseItem = {};
        this.hasChanged = false;
        this.resetDiscountState();
      },

      async submitForm() {
        // if (!this.form.dateRange || this.form.dateRange.length === 0) {
        //   this.$message.warning(this.$t("components.Add.800967-51"));
        //   return;
        // }
        if (!this.form.name[this.languages[0].code]) {
          this.$message.warning(this.$t("components.Add.800967-52"));
          return;
        }
        if (!this.form.description[this.languages[0].code]) {
          this.$message.warning(this.$t("components.Add.800967-53"));
          return;
        }

        if (this.content.length === 0 && this.form.type === 2) {
          this.$message.warning(this.$t("components.Add.800967-54"));
          return;
        }

        const formData = {
          id: this.isEdit ? this.editData.id : undefined,
          startTime: this.form.dateRange[0],
          endTime: this.form.dateRange[1],
          discountId: this.form.discountId,
          type: this.form.type,
          url: this.form.url,
          language: [],
          questions: []
        };

        this.languages.forEach(lang => {
          // 确保每种语言都会添加到language数组中，即使description为空
          formData.language.push({
            lang: lang.code,
            title: this.form.name[lang.code] || "",
            description: this.form.description[lang.code] || ""
          });
        });

        this.content.forEach((item, index) => {
          const question = {
            id: item.id || undefined,
            surveyId: this.isEdit ? this.editData.id : undefined,
            type: this.reverseMapQuestionType(item.type),
            required: item.required ? 1 : 0,
            sort: index + 1,
            language: [],
            options: []
          };

          this.languages.forEach(lang => {
            if (item.title[lang.code] || item.placeholder[lang.code]) {
              question.language.push({
                questionId: item.id || undefined,
                lang: lang.code,
                title: item.title[lang.code] || "",
                placeholder: item.placeholder[lang.code] || "",
                defaultValue: ""
              });

              if (item.type === "rating" && item.textareaPlaceholder[lang.code]) {
                question.language[question.language.length - 1].textareaPlaceholder =
                  item.textareaPlaceholder[lang.code] || "";
              }
            }
          });

          if (item.list && (item.type === "radio" || item.type === "checkbox")) {
            item.list.forEach((option, optIndex) => {
              const optionItem = {
                id: option.id || undefined,
                questionId: item.id || undefined,
                sort: optIndex + 1,
                language: []
              };

              this.languages.forEach(lang => {
                if (option.label[lang.code]) {
                  optionItem.language.push({
                    optionsId: option.id || undefined,
                    lang: lang.code,
                    title: option.label[lang.code] || ""
                  });
                }
              });

              question.options.push(optionItem);
            });
          }

          formData.questions.push(question);
        });

        try {
          this.submitLoading = true;
          const url = this.isEdit ? this.$url.Survey.update : this.$url.Survey.insert;
          const method = this.isEdit ? this.$method.put : this.$method.post;
          const res = await this.$api.request(url, method, formData);
          if (res.code != 0) {
            this.$message.warning(res.msg);
            return;
          }
          this.hasChanged = true;
          this.$message.success(
            this.isEdit ? this.$t("components.Add.800967-55") : this.$t("components.Add.800967-56")
          );
          this.closeDialog();
        } catch (error) {
          console.error(this.isEdit ? this.$t("components.Add.800967-57") : this.$t("components.Add.800967-58"), error);
          this.$message.error(this.isEdit ? this.$t("components.Add.800967-57") : this.$t("components.Add.800967-58"));
        } finally {
          this.submitLoading = false;
        }
      },

      handlerAddInTable() {
        if (!this.chooseItem || (this.chooseItem.type !== "radio" && this.chooseItem.type !== "checkbox")) {
          return;
        }

        if (!this.chooseItem.list) {
          this.chooseItem.list = [];
        }

        const newOptionValue = `option${Date.now()}`;

        const newOption = {
          value: newOptionValue,
          label: this.createMultiLangObject(this.$t("components.Add.800967-59", [this.chooseItem.list.length + 1]))
        };

        this.chooseItem.list.push(newOption);
      }
    }
  };
</script>

<style lang="scss" scoped>
  ::v-deep(.el-dialog__body) {
    padding-top: 0;
    padding-bottom: 0;
  }
  ::v-deep(.el-form-item__label) {
    padding: 0;
  }
  .custom-date-picker {
    width: 100%;
    .el-input__inner {
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      &:hover {
        border-color: #409eff;
      }
    }
  }
  .preview-container {
    max-height: 500px;
    overflow-y: auto;
    padding: 0 10px;
    user-select: none;
  }
  .component-list {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;

    li {
      width: 100%;
      margin-bottom: 10px;
      border-radius: 6px;
      padding: 10px 5px;
      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
      text-align: center;
      cursor: pointer;
      transition: all 0.3s;
    }

    li:hover {
      background-color: #f5f7fa;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
  .choose-item {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 6px;
    z-index: 1;
  }
  .choose-active {
    border: 1px dashed #409eff;
  }
  .form-item-container {
    border-radius: 6px;
    transition: all 0.3s;
    background-color: #fff;
  }
  .form-item-container:hover {
    box-shadow: 0 0 8px rgba(64, 158, 255, 0.3);
  }
  .item-actions {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2;
    display: none;
  }
  .form-item-container:hover .item-actions {
    display: flex;
  }
  .item-actions i {
    margin-left: 5px;
    background: #fff;
    border-radius: 50%;
    padding: 5px;
    font-size: 16px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
  .drag-handle {
    cursor: move;
    color: #409eff;
  }
  .el-icon-close {
    color: #f56c6c;
  }

  .el-rate {
    margin-bottom: 10px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 15px;
  }

  ::v-deep .el-switch {
    margin-top: 5px;
  }

  ::v-deep .el-textarea__inner {
    min-height: 80px;
  }
</style>
